import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Import utilities
import { useOperators } from 'components/utilities';

// Import styles
import { Wrapper, Paragraph } from './styles';

// Import components
import ProductPackets from './ProductPackets';

const Packets = ({ playerType, message }) => {
	const { t } = useTranslation();

	const { isRetailOrGuest, isOperator, operator } = useOperators();

	return (
		<Wrapper>
			{isOperator && (
				<Paragraph>
					{t(`opertators_player_resources_not_in_products_${operator}`)}
				</Paragraph>
			)}

			{isRetailOrGuest && (
				<ProductPackets playerType={playerType} message={message} />
			)}
		</Wrapper>
	);
};

Packets.propTypes = {
	playerType: PropTypes.string,
	message: PropTypes.string
};

export default Packets;
